import React from 'react';

import { EmergencyFundHeader } from './EmergencyFundHeader';
import { MajorPurchaseHeader } from './MajorPurchaseHeader';
import { RetirementGrowthHeader } from './RetirementGrowthHeader';

import { PurposeProjectionQuery } from '../../graphql/purposeProjection.generated';

export const ProjectionHeader: React.FC<{ purpose: PurposeProjectionQuery['purpose'] }> = ({ purpose }) => {
  switch (purpose.__typename) {
    case 'PurposeMajorPurchase':
      return <MajorPurchaseHeader purpose={purpose} />;
    case 'PurposeEmergencyFund':
      return <EmergencyFundHeader purpose={purpose} />;
    case 'PurposeRetirementGrowth':
      return purpose.targetMonthlySpendingAmount ? <RetirementGrowthHeader purpose={purpose} /> : null;
    case 'PurposeRetirementIncome':
    default:
      return null;
  }
};
